import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "src/app/auth/service/login.service";

@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public historia: string;
  public profileImg: "/src/assets/images/dashboard/user_profile.png";

  constructor(
    public _router: Router,
    private authService: LoginService) { }

  ngOnInit() {
    // const token = localStorage.getItem("token");
    // if (token) {
    //   var dataUser = JSON.parse(atob(token.split('.')[1]));
    //   this.userName = dataUser['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    //   this.historia = dataUser['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
    // }
    const token = localStorage.getItem("token");
    if (token) {
      const tokenData = JSON.parse(atob(token.split('.')[1]));
      const expirationTime = new Date(tokenData.exp * 1000);
      const currentTime = new Date();

      if (expirationTime <= currentTime) {
        localStorage.removeItem("token");
        this._router.navigateByUrl('auth/login');
      } else {
        this.userName = tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
        this.historia = tokenData['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
      }
    } else {
      this._router.navigateByUrl('auth/login');
    }
  }

  logoutFunc() {
    this.authService.logout();
  }

  misdatos() {
    this._router.navigateByUrl('menu/mis-datos')
  }
}
